import Vue from 'vue'
import Router from 'vue-router'
// import adLayout from '@/layout/ad'
import usLayout from '@/layout/us'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/us',
    component: usLayout,
    children: [
      {
        name: 'home',
        path: '/home',
        component: () => import('@/views/us/home'),
        meta: {
          title: '首页'
        }
      },
      {
        name: 'brief',
        path: '/brief',
        component: () => import('@/views/us/intro/brief'),
        meta: {
          title: '简介'
        }
      },
      {
        name: 'organization',
        path: '/organization',
        component: () => import('@/views/us/intro/organization'),
        meta: {
          title: '组织架构'
        }
      },
      {
        name: 'rule',
        path: '/rule',
        component: () => import('@/views/us/intro/rule'),
        meta: {
          title: '章程'
        }
      },
      {
        name: 'news',
        path: '/news',
        component: () => import('@/views/us/news'),
        meta: {
          title: '文化要闻'
        }
      },
      {
        name: 'moments',
        path: '/moments',
        component: () => import('@/views/us/moments'),
        meta: {
          title: '中心动态'
        }
      },
      {
        name: 'exchange',
        path: '/exchange',
        component: () => import('@/views/us/exchange'),
        meta: {
          title: '文化交流'
        }
      },
      // {
      //   name: 'council_intro',
      //   path: '/council_intro',
      //   component: () => import('@/views/us/council/intro'),
      //   meta: {
      //     title: '理事介绍'
      //   }
      // },
      {
        name: 'council_demeanour',
        path: '/council_demeanour',
        component: () => import('@/views/us/council/demeanour'),
        meta: {
          title: '理事风采'
        }
      },
      {
        name: 'council_composition',
        path: '/council_composition',
        component: () => import('@/views/us/council/composition'),
        meta: {
          title: '理事名作'
        }
      },
      {
        name: 'rostrum',
        path: '/rostrum',
        component: () => import('@/views/us/rostrum'),
        meta: {
          title: '名家讲坛'
        }
      },
      {
        name: 'search',
        path: '/search',
        component: () => import('@/views/us/search'),
        meta: {
          title: '搜索'
        }
      },
      {
        name: 'detail',
        path: '/detail',
        component: () => import('@/views/us/detail'),
        meta: {
          title: '文章详情'
        }
      },
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  }
]

const createRouter = () => new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export default router
